import { head } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useUsersState } from '../_load/UsersLoader'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'
import { useUserActionsList } from '../../../../utils/actions/users/list'

const MultiRowsActions = () => {
  const { users, usersCount } = useUsersState()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedUsers = getSelectedData(users)
  const menuOptions = useUserActionsList(head(selectedUsers), selecteds)

  return <MultiSelectMenu options={menuOptions} />
}

export default MultiRowsActions
